import React from 'react';
import {connect} from 'react-redux';
import {Segment, Header, Loader} from 'semantic-ui-react';
import {FemaGoTable} from 'app-ui-componentlibrary';
import {connectDynamic} from '../../dynamicComponent';
import {Alert} from 'componentLibrary';
import REST from 'go/requests/rest';
import _ from 'lodash';
import {convertDateForDisplay, isFemaUser} from 'common/utils';
import ApiActions from 'go/actions/api';
import {API_TASK_UNASSIGN_SUCCESS, API_TASK_ASSIGN_POST_SUCCESS} from 'common/types';
import {push} from 'react-router-redux';

export class PendingTasks extends React.Component {
  state = {
    tasks: [],
    taskSummary: [],
    loadingTasks: false,
    error: false,
    loading: true,
  };

  getTaskSummary() {
    return REST.workflow
      .getTaskSummary(this.props.token)
      .then(REST.handler.handleResponse)
      .then((taskSummary) => {
        this.setState({
          taskSummary: taskSummary,
        });
      });
  }

  refreshTasks() {
    const {token, grantId, hasFemaPermissions, subGrantId, flagGLP} = this.props;
    if (hasFemaPermissions && (grantId || subGrantId)) {
      const isGrant = !_.isEmpty(grantId);
      const restCall = isGrant
        ? REST.workflow.getTasksForGrant
        : REST.workflow.getTasksForSubGrant;
      const id = grantId || subGrantId;
      return restCall(token, id)
        .then(REST.handler.handleResponse)
        .then((tasks) => {
          if (isGrant) {
            tasks = _.filter(tasks, (task) => {
              if (task.taskScope && task.taskScope === 'grant')
                return true;
              else if (task.taskScope && task.taskScope === 'subGrant')
                return false;
              else
                return task.subGrantId ? false : true;
            });
          } else {
            tasks = _.filter(tasks, (task) => {
              if (task.taskScope && task.taskScope === 'grant')
                return false;
              else if (task.taskScope && task.taskScope === 'subGrant')
                return true;
              else
                return task.grantId ? false : true;
            });
          }
          const userIds = _.filter(
            _.map(tasks, (task) => task.assignee),
            (userId) => !!userId
          );
          const userIdPayload = {
            userId: userIds,
          };
          if (!_.isEmpty(userIds)) {
            return REST.user
              .getProfilesForUsers(token, userIdPayload)
              .then(REST.handler.handleResponse)
              .then((users) => {
                const userMappedTasks = _.map(tasks, (task) => {
                  return {
                    ...task,
                    profile: _.find(users, (user) => task.assignee === user.userId),
                  };
                });
                this.setState(
                  {
                    tasks: userMappedTasks,
                    loading: false,
                  },
                  () => {
                    if (this.props.saveTaskToSessionPath) {
                      this.props.saveEntitySessionData(
                        this.props.saveTaskToSessionPath,
                        tasks
                      );
                    }
                  }
                );
              });
          } else {
            this.setState(
              {
                loading: false,
                tasks,
              },
              () => {
                if (this.props.saveTaskToSessionPath) {
                  this.props.saveEntitySessionData(
                    this.props.saveTaskToSessionPath,
                    tasks
                  );
                }
              }
            );
          }
        })
        .catch((err) => {
          console.error('err');
          this.setState({
            error: true,
            loading: false,
          });
        });
    }
  }

  componentDidUpdate(prevProps) {
    const {grantId, subGrantId, messages} = this.props;
    if (
      grantId !== prevProps.grantId ||
      subGrantId !== prevProps.subGrantId ||
      messages !== prevProps.messages
    ) {
      this.getTaskSummary().then(this.refreshTasks());
    }
  }

  componentDidMount() {
    this.getTaskSummary().then(this.refreshTasks());
  }

  hasPermissions = (taskPermissions) => {
    const {permissions} = this.props;
    return _.intersection(permissions, taskPermissions).length > 0;
  };

  handleUnassignTask = (id) => {
    const {unassignTask, token} = this.props;
    const {tasks} = this.state;
    unassignTask(token, id).then((res) => {
      if (res && res.type === API_TASK_UNASSIGN_SUCCESS) {
        _.find(tasks, (task) => task.id === id).assignee = null;
        this.setState({tasks});
      }
    });
  };

  handleAssignTask = (id, name) => {
    const {assignTask, token, navigateToTask} = this.props;
    assignTask(token, id).then((res) => {
      if (res && res.type === API_TASK_ASSIGN_POST_SUCCESS) {
        navigateToTask(`${id}#${name}`);
      }
    });
  };

  renderAssignee = (id, assignedUserId, assignedProfile = {}, hasPermissions) => {
    const {userId} = this.props;
    const {
      emailAdr: assignedEmail,
      firstName: assignedFirst,
      lastName: assignedLast,
    } = assignedProfile;

    const unassignLink = assignedUserId && hasPermissions && (
      <a
        href={`#${id}`}
        title={assignedUserId}
        onClick={(e) => {
          e.preventDefault();
          this.handleUnassignTask(id);
        }}
      >
        (Unassign)
      </a>
    );
    const userDisplay =
      assignedUserId === userId
        ? 'You'
        : assignedUserId
        ? assignedFirst + ' ' + assignedLast
        : 'Unassigned';
    return (
      <React.Fragment>
        {userDisplay} {unassignLink}
      </React.Fragment>
    );
  };

  renderAction = (task) => {
    const {email, navigateToTask, navigateToBulkTask, userId} = this.props;
    const {assignee, id, excludedPerformer, name} = task;
    const processDefKey = task.processDefinitionKey;
    const taskDefKey = task.taskDefinitionKey;
    const activityName = task.name;
    const taskSummary = _.find(this.state.taskSummary, (taskSummary) => {
      return taskSummary.taskDefKey === taskDefKey;
    });
    const allowBulkCompletion = _.get(taskSummary, 'allowBulkCompletion', false);
    switch (assignee) {
      case null:
        return !_.includes(excludedPerformer, userId) ? (
          <a
            href={`#${allowBulkCompletion ? '' : name}`}
            title={activityName}
            onClick={() => {
              allowBulkCompletion
                ? navigateToBulkTask(processDefKey, taskDefKey)
                : this.handleAssignTask(id, name);
            }}
          >
            Start task &gt;
          </a>
        ) : (
          'You are not eligible to complete this task'
        );
      case userId:
        return (
          <a
            href={`#${allowBulkCompletion ? '' : name}`}
            title={activityName}
            onClick={() => {
              allowBulkCompletion
                ? navigateToBulkTask(processDefKey, taskDefKey)
                : navigateToTask(`${id}#${name}`);
            }}
          >
            Continue task &gt;
          </a>
        );
      default:
        return;
    }
  };

  render() {
    const {tasks, error, loading} = this.state;

    if (!this.props.hasFemaPermissions) {
      return <React.Fragment />;
    } else {
      return (
        <Segment>
          <Header as="h2">Pending Tasks</Header>
          {error && (
            <Alert
              header="Error retrieving pending tasks"
              content="There was a problem retrieving pending tasks for this grant"
              type="error"
              dismissable={false}
            />
          )}
          {!error && loading && <Loader active>Loading...</Loader>}
          {!error && !loading && _.isEmpty(tasks) && (
            <Alert
              header="No pending tasks"
              content="There are currently no pending tasks for this grant"
              type="info"
              dismissable={false}
            />
          )}

          {!error && !loading && !_.isEmpty(tasks) && (
            <FemaGoTable
              summary={'Pending tasks for this grant.'}
              type="static"
              columns={4}
            >
              <FemaGoTable.Header>
                <FemaGoTable.Row>
                  <FemaGoTable.HeaderCell>Task</FemaGoTable.HeaderCell>
                  <FemaGoTable.HeaderCell>Date in queue</FemaGoTable.HeaderCell>
                  <FemaGoTable.HeaderCell>Assigned to</FemaGoTable.HeaderCell>
                  <FemaGoTable.HeaderCell>Action</FemaGoTable.HeaderCell>
                </FemaGoTable.Row>
              </FemaGoTable.Header>
              <FemaGoTable.Body>
                {_.map(tasks, (task) => (
                  <FemaGoTable.Row key={task.id}>
                    <FemaGoTable.TextCell>{task.name}</FemaGoTable.TextCell>
                    <FemaGoTable.TextCell>
                      {convertDateForDisplay(task.created, true)}
                    </FemaGoTable.TextCell>
                    <FemaGoTable.TextCell>
                      {this.renderAssignee(
                        task.id,
                        task.assignee,
                        task.profile,
                        this.hasPermissions(task.candidate)
                      )}
                    </FemaGoTable.TextCell>
                    <FemaGoTable.TextCell>
                      {this.hasPermissions(task.candidate) && this.renderAction(task)}
                    </FemaGoTable.TextCell>
                  </FemaGoTable.Row>
                ))}
              </FemaGoTable.Body>
            </FemaGoTable>
          )}
        </Segment>
      );
    }
  }
}

export const mapStateToProps = (state) => {
  return {
    email: state.auth.emailAdr,
    userId: state.auth.userId,
    token: state.auth.token,
    permissions: state.auth.permissions,
    firstName: state.auth.firstName,
    lastName: state.auth.lastName,
    hasFemaPermissions: isFemaUser(state.auth.permissions),
    messages: state.messages && state.messages.messages ? state.messages.messages : false,
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    unassignTask: (token, id) => {
      const action = ApiActions.tasks.unassignTask(token, id);
      const response = dispatch(action);
      return response;
    },
    assignTask: (token, id) => {
      const action = ApiActions.tasks.assignTask(id, token);
      const response = dispatch(action);
      return response;
    },
    navigateToTask: (taskId) => {
      dispatch(push('/tasks/' + taskId));
    },
    navigateToBulkTask: (processDefKey, taskDefKey) => {
      dispatch(
        push(
          `/tasks/bulk/list?processDefinitionKey=${processDefKey}&taskDefinitionKey=${taskDefKey}`
        )
      );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(connectDynamic(PendingTasks));
